import Box from "ds/components/Box";
import Typography from "ds/components/Typography";

import { ChangeHistoryDateGroup as ChangeHistoryDateGroupType, InputSnapshot } from "../types";
import ChangeHistoryCard from "../ChangeHistoryCard";
import styles from "./styles.module.css";

type ChangeHistoryDateGroupProps = {
  group: ChangeHistoryDateGroupType;
  templateId: string;
  deploymentId: string;
  currentInputs: InputSnapshot[];
  currentVersionNumber: string;
  latestEntryId: string | undefined;
};

const ChangeHistoryDateGroup = ({
  group,
  templateId,
  deploymentId,
  currentInputs,
  currentVersionNumber,
  latestEntryId,
}: ChangeHistoryDateGroupProps) => (
  <Box direction="column" gap="small" relative className={styles.dateGroup}>
    <Box align="center" gap="medium">
      <Box align="center" justify="center" shrink="0" className={styles.dateBullet}>
        <div className={styles.dateBulletDot} />
      </Box>
      <Typography tag="span" variant="p-body3" color="secondary">
        {group.dateLabel}
      </Typography>
    </Box>

    <Box direction="column" gap="medium" className={styles.entriesWrapper}>
      {group.entries.map((entry) => (
        <ChangeHistoryCard
          key={entry.id}
          entry={entry}
          templateId={templateId}
          deploymentId={deploymentId}
          currentInputs={currentInputs}
          currentVersionNumber={currentVersionNumber}
          isLatest={entry.id === latestEntryId}
        />
      ))}
    </Box>
  </Box>
);

export default ChangeHistoryDateGroup;
